import React from 'react';
import { ArrowRightIcon, ArrowUpRightIcon } from 'lucide-react';
export const HeroSection = () => {
  const stats = [{
    value: '42%',
    label: 'Average Revenue Increase'
  }, {
    value: '85%',
    label: 'Sponsor Retention Rate'
  }, {
    value: '3.8x',
    label: 'ROI on Our Services'
  }];
  return <section className="w-full bg-white py-16 md:py-32 relative overflow-hidden text-black" data-id="element-194">
      {/* Animated Wave Background */}
      <div className="absolute inset-0 w-full h-full overflow-hidden z-0" data-id="element-195">
        <div className="wave-container" data-id="element-196">
          <div className="wave wave1" data-id="element-197"></div>
          <div className="wave wave2" data-id="element-198"></div>
          <div className="wave wave3" data-id="element-199"></div>
          <div className="wave wave4" data-id="element-200"></div>
        </div>
        <style jsx data-id="element-201">{`
          .wave-container {
            position: absolute;
            width: 100%;
            height: 75%;
            bottom: 0;
            overflow: hidden;
          }
          .wave {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 200%;
            height: 100%;
            background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 320'%3E%3Cpath fill='%23FF7A39' fill-opacity='0.1' d='M0,192L48,186.7C96,181,192,171,288,186.7C384,203,480,245,576,234.7C672,224,768,160,864,144C960,128,1056,160,1152,170.7C1248,181,1344,171,1392,165.3L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z'%3E%3C/path%3E%3C/svg%3E");
            background-repeat: repeat-x;
            background-position: 0 bottom;
            background-size: 100% 100%;
            transform: translateZ(0);
          }
          .wave1 {
            opacity: 0.3;
            animation: wave 12s linear infinite;
            z-index: 1000;
            animation-delay: 0s;
            bottom: 0;
          }
          .wave2 {
            opacity: 0.2;
            animation: wave2 10s linear infinite;
            z-index: 999;
            animation-delay: -5s;
            bottom: 10px;
          }
          .wave3 {
            opacity: 0.1;
            animation: wave 18s linear infinite;
            z-index: 998;
            animation-delay: -2s;
            bottom: 15px;
          }
          .wave4 {
            opacity: 0.05;
            animation: wave2 15s linear infinite;
            z-index: 997;
            animation-delay: -7s;
            bottom: 20px;
          }
          @keyframes wave {
            0% {
              transform: translateX(0);
            }
            50% {
              transform: translateX(-25%);
            }
            100% {
              transform: translateX(-50%);
            }
          }
          @keyframes wave2 {
            0% {
              transform: translateX(0);
            }
            50% {
              transform: translateX(-15%);
            }
            100% {
              transform: translateX(-30%);
            }
          }
        `}</style>
      </div>
      <div className="absolute top-0 right-0 w-16 h-16 md:w-24 md:h-24 bg-[#FF7A39]/40 rounded-bl-3xl" data-id="element-202"></div>
      <div className="absolute bottom-0 left-0 w-20 h-20 md:w-36 md:h-36 bg-[#FF7A39]/30 rounded-tr-3xl" data-id="element-203"></div>
      <div className="container mx-auto px-6 relative z-10" data-id="element-204">
        <div className="mb-5" data-id="element-205">
          <span className="text-black font-medium inline-flex items-center gap-2 bg-black/5 px-4 py-1.5 rounded-full shadow-sm backdrop-blur-sm" data-id="element-206">
            <div className="w-6 h-6 bg-[#FF7A39] rounded-sm" data-id="element-207"></div>
            B2B Sponsorship Sales Agency
          </span>
        </div>
        <div className="max-w-5xl mb-8 md:mb-12" data-id="element-208">
          <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6 text-black" data-id="element-209">
            We build{' '}
            <span className="font-serif italic text-[#FF7A39]" data-id="element-210">
              high-performing
            </span>{' '}
            sponsorship engines for B2B events
          </h1>
          <p className="text-lg md:text-2xl text-black/80 max-w-2xl" data-id="element-211">
            We build, optimize, and scale sponsorship sales that generate
            pipeline and improve marketing ROI.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-5 mb-10 md:mb-16" data-id="element-212">
          <a href="https://calendar.app.google/UHmu8gqmNjGApsL99" className="bg-[#FF7A39] hover:bg-[#FF7A39]/90 text-black px-6 py-4 rounded-md font-medium text-lg transition-all flex items-center justify-center gap-2 w-full sm:w-fit shadow-md" data-id="element-213">
            Schedule a Free Consultation <ArrowUpRightIcon size={18} data-id="element-214" />
          </a>
          <a href="#services" className="bg-black/10 backdrop-blur-sm border border-black/10 text-black px-6 py-4 rounded-md font-medium text-lg hover:bg-black/15 transition-all flex items-center justify-center gap-2 w-full sm:w-fit shadow-sm" data-id="element-215">
            Our Services <ArrowRightIcon size={18} data-id="element-216" />
          </a>
        </div>
        {/* Key Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl" data-id="element-217">
          {stats.map((stat, index) => <div key={index} className="bg-black/5 backdrop-blur-sm p-5 md:p-7 rounded-lg shadow-md hover:shadow-lg transition-all border border-black/5 transform hover:-translate-y-1 duration-300" data-id="element-218">
              <div className="flex items-center gap-3 mb-2" data-id="element-219">
                <span className="text-4xl font-bold text-[#FF7A39]" data-id="element-220">
                  {stat.value}
                </span>
              </div>
              <p className="text-black/70 font-medium" data-id="element-221">{stat.label}</p>
            </div>)}
        </div>
      </div>
    </section>;
};